import React, { Component } from 'react';
import Select from 'react-select';

// eslint-disable-next-line
import style from './_style.css';

export default class MultiSelectInput extends Component {
    
    state = {
        isClearable: false,
        isDisabled: false,
        isLoading: false,
        isRtl: false,
        isSearchable: true,
        defaultValue: this.props.defaultValue,
        options: this.props.options,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.defaultValue !== state.defaultValue || props.options !== state.options) {
            state.defaultValue = props.defaultValue;
            state.options = props.options;
            return state;
        }
        return null;
    }

    render() {
        const {
            isClearable,
            isSearchable,
            isDisabled,
            isLoading,
            isRtl,
            defaultValue,
            options,
        } = this.state;
        return (
            <div className={'flex_full_column padding_top_16 multiselectinput'}>
                {defaultValue && defaultValue.length > 0 && (
                    <span className="select-input-label">{this.props.placeHolder}</span>
                )}
                <Select
                    placeholder={this.props.placeHolder}
                    className={"basic-single " + this.props.extraClass}
                    classNamePrefix="select"
                    value={defaultValue ? defaultValue : null}
                    isDisabled={isDisabled}
                    isLoading={isLoading}
                    isClearable={isClearable}
                    isRtl={isRtl}
                    isSearchable={isSearchable}
                    name="color"
                    options={options}
                    onChange={this.props.onChange}
                    isMulti={!this.props.isSimple}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/MultiSelectInput.js